import { AbilityBuilder, PureAbility } from '@casl/ability';

import { User, UserRole } from 'src/app/models/User';
import { environment } from 'src/environments/environment';

export const AppSubject = {
  User: 'User',
  Currency: 'Currency',
  Country: 'Country',
  Customer: 'Customer',
  TableFilter: 'TableFilter',
  Address: 'Address',
  CustomerCorrespondence: 'CustomerCorrespondence',
  CustomerContactPerson: 'CustomerContactPerson',
  Appointment: 'Appointment',
  UserWidget: 'UserWidget'
} as const;

export type AppAction = 'create' | 'read' | 'update' | 'delete';

export type AppSubject = (typeof AppSubject)[keyof typeof AppSubject];

export type AppAbility = PureAbility<
  [AppAction | 'manage', AppSubject | 'all']
>;

export const abilityFactory = (user: User | null): AppAbility | null => {
  if (!user) {
    return null;
  }

  const { can, build } = new AbilityBuilder<AppAbility>(PureAbility);

  // Global permissions

  can('read', 'Currency');
  can('read', 'Country');

  can('manage', 'TableFilter');
  can('manage', 'UserWidget');

  switch (user.role) {
    case UserRole.TechnicalAdmin:
      can('manage', 'all');

      return build();

    case UserRole.Admin:
      can('manage', 'all');

      return build();

    case UserRole.User:
      can('read', 'Customer');
      can('read', 'CustomerContactPerson');
      can('read', 'Address');
      can('read', 'CustomerCorrespondence');

      return build();

    default:
      return null;
  }
};

export const cookieKeys = {
  accessToken: `${environment.env}-access-token`,
  refreshToken: `${environment.env}-refresh-token`
} as const;
